import localforage from 'localforage'
import _ from 'lodash'

class NomBouteille {
    getList(callback) {
        localforage
            .getItem('listNomBout')
            // Handler d'erreur en 2e argument de .then() et non en .catch() :
            // un .catch() enchaine ici avalerait aussi les erreurs levees par
            // callback(), pas seulement l'echec de lecture du stockage.
            .then(noms => {
                callback(_.sortBy(JSON.parse(noms), ['nom']))
            }, err => {
                console.error("Chargement des noms de bouteille impossible (listNomBout)", err)
            })
    }
}

export default NomBouteille



// WEBPACK FOOTER //
// ./src/js/models/NomBouteille.js